import React from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import ErrorCard from '../Common/ErrorCard';

export const NoAuthServer = () => {
    const [params] = useSearchParams()

    return <ErrorCard details="" message={"Authentication server not found: " + params.get("authority") + ". Please try log in again."} />

    // return (
    //     <div className="danger" role="alert">
    //         Authentication Server Not Found ({params.get("authority")})

    //         <p><Button icon='refresh' onClick={() => navigate('/')}>Retry</Button></p>
    //     </div>

    // )
} 
